//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ResizeSensor } from 'css-element-queries';
import { mapGetters } from 'vuex';
import { PALETTE_COLOURS } from '@/store/types/getters';
import { COLOURS } from '@/store/types/namespaces';

export default {
  name: 'DpGauge',
  props: {
    strokeWidth: { type: Number, default: 25 },
    isPercent: { type: Boolean, default: false },
    value: { type: [Number, String], default: 0 },
    rawValue: { type: Number, default: 0 },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    state: { type: String, default: null },
    factor: { type: Number, default: 1 },
    units: { type: String, default: null },
  },
  data() {
    return {
      radius: 100,
      isHorizontalSpace: false,
      draw: false,
      resizeSensor: null,
    };
  },
  computed: {
    ...mapGetters(COLOURS, [PALETTE_COLOURS]),
    backgroundColour() {
      return this[PALETTE_COLOURS].neutral[1];
    },
    foregroundColour() {
      const colours = this[PALETTE_COLOURS];
      if (!this.state) return colours.primary;
      return colours[this.state];
    },
    minMaxFontColour() {
      return this[PALETTE_COLOURS].neutral[6];
    },
    mainText() {
      const { value, rawValue, isPercent } = this;
      let text = value || rawValue;
      if (!value && isPercent) {
        text = `${text}%`;
      }
      return text;
    },
    fontSize() {
      if (!this.mainText) return 0;
      const { length } = `${this.mainText}`;
      const maxSize = 32;
      return maxSize - (length / 1.5);
    },
    normalisedRadius() {
      const normalised = this.radius - this.strokeWidth * 2;
      // Double it because we only display half of the circle
      return normalised;
    },
    circleRadius() {
      return (this.normalisedRadius * 4) - this.strokeWidth;
    },
    normalisedCircumference() {
      return this.circumference - (this.strokeWidth * 3);
    },
    diameter() {
      return this.radius * 2;
    },
    circumference() {
      const circumference = this.normalisedRadius * 2 * Math.PI;
      return circumference * 2;
    },
    factoredMinValue() {
      return this.minValue / this.factor;
    },
    factoredMaxValue() {
      return this.maxValue / this.factor;
    },
    displayedMinValue() {
      const { minValue, isPercent } = this;
      if (!minValue && isPercent) {
        return 0;
      }
      return minValue;
    },
    displayedMaxValue() {
      const { maxValue, isPercent } = this;
      if (!maxValue && isPercent) {
        return 100;
      }
      return maxValue;
    },
    percent() {
      const minValue = this.factoredMinValue;
      const maxValue = this.factoredMaxValue;
      if (!this.isPercent && (this.minValue === null || this.maxValue === null)) {
        return 1;
      }

      const min = this.isPercent ? 0 : minValue;
      const max = this.isPercent ? 100 : maxValue;

      const percent = (this.rawValue - min) / (max - min);
      return Math.max(Math.min(percent, 1), 0);
    },
    strokeDashOffset() {
      return this.normalisedCircumference * this.percent;
    },
  },
  mounted() {
    this.checkContainerShape();
    this.resizeSensor = new ResizeSensor(this.$el, this.checkContainerShape);
  },
  beforeDestroy() {
    if (!this.$el || !this.resizeSensor) {
      return;
    }
    this.resizeSensor.detach(this.$el);
    delete this.resizeSensor;
  },
  methods: {
    checkContainerShape() {
      const { clientHeight, clientWidth } = this.$el;
      const offset = 120;
      this.isHorizontalSpace = clientWidth - offset >= clientHeight;
      this.draw = false;

      setTimeout(() => {
        this.draw = true;
      }, 100);
    },
  },
};
